var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nav',{staticClass:"breadcrumb",attrs:{"aria-label":"breadcrumb"}},_vm._l((_vm.items),function(v,index){return _c('a',{key:index,class:[v.active && 'active'],on:{"click":function($event){return _vm.$router.push(v.link)}}},[_c('Typography',{attrs:{"text":v.name,"variant":"labelBold"}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }